import { AfterViewInit, Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { NavBarComponent } from '../../components/nav-bar/nav-bar';
import { AnalysesHeaderComponent } from '../../components/analyses-header/analyses-header';
import { SortAndFilterBarComponent } from '../../components/sort-and-filter-bar/sort-and-filter-bar';
import { MyAnalysesComponent } from '../../components/my-analyses/my-analyses';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

/**
 * Generated class for the AnalysesPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-analyses',
  templateUrl: 'analyses.html',
  styleUrls: ['./analyses.scss'],
  standalone: false,
  imports: [
    IonicModule,
    SortAndFilterBarComponent,
//    NavBarComponent,
    AnalysesHeaderComponent,
    MyAnalysesComponent,
    TranslateModule,
    CommonModule,
    FormsModule
  ]
})
export class AnalysesPage implements AfterViewInit {
  public static PATH: string = 'analyses';

  constructor() {
  }

  ngAfterViewInit() {
    console.log('ngAfterViewInit AnalysesPage');
  }

}
